/* eslint import/no-unresolved: "off", no-console: "off" */
const initNavbar = () => {
  import('navbar/init')
    .then((navbar) => {
      navbar.default();
    })
    .catch((error) => console.warn('Navbar did not initiate!', error));
};

const initFooter = () => {
  import('footer/init')
    .then((footer) => {
      footer.default();
    })
    .catch((error) => console.warn('Navbar did not initiate!', error));
};

export { initNavbar, initFooter };
